import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { EntityZaloOAApi } from 'api';

export const genIdentityZaloKey = createAsyncThunk(
  'EntityZaloOA/genIdentityZaloKey',
  async (option: any, { rejectWithValue }) => {
    try {
      const response = await EntityZaloOAApi.genZaloKey(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const checkZaloOACanDelete = createAsyncThunk(
  'EntityZaloOA/checkZaloOACanDelete',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await EntityZaloOAApi.checkZaloOACanDelete(id);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const confirmZaloAccessToken = createAsyncThunk(
  'EntityZaloOA/confirmZaloAccessToken',
  async (body: any, { rejectWithValue }) => {
    try {
      const response = await EntityZaloOAApi.confirmAccessToken(body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findZaloOAWWithEntity = createAsyncThunk(
  'EntityZaloOA/findZaloOAWWithEntity',
  async (body: any, { rejectWithValue }) => {
    try {
      const response = await EntityZaloOAApi.findZaloWithEntity(body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findOneZaloOAWWithEntity = createAsyncThunk(
  'EntityZaloOA/findOneZaloOAWWithEntity',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await EntityZaloOAApi.findOne(id);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const updateZaloOAWWithEntity = createAsyncThunk(
  'EntityZaloOA/updateZaloOAWWithEntity',
  async (option: any, { rejectWithValue }) => {
    try {
      const response = await EntityZaloOAApi.update(option.id, option.body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const deleteEntityZaloOA = createAsyncThunk(
  'entityTask/deleteEntityZaloOA',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await EntityZaloOAApi.delete(id);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

interface IState {
  EntityZaloOAs: Array<any>;
  isFirstLoading: boolean;
  reloadFlag: boolean;
}

const initialState: IState = {
  EntityZaloOAs: [],
  isFirstLoading: false,
  reloadFlag: false,
};

const entityZaloOASlice = createSlice({
  name: 'entityZaloOA',
  initialState,
  reducers: {
    reloadEntityZaloOA(state) {
      state.reloadFlag = !state.reloadFlag;
    },
  },
});

const { actions, reducer: entityZaloOAReducer } = entityZaloOASlice;

export const { reloadEntityZaloOA } = actions;

export default entityZaloOAReducer;
